export type AiSuggestionsState = 'On' | 'Off' | 'Blocked';

/** A blocked team reads as Blocked whatever aiEnabled says; `undefined` means the state is unknown. */
export const getAiSuggestionsState = (
  aiEnabled?: boolean,
  aiBlocked?: boolean,
): AiSuggestionsState | undefined => {
  if (aiBlocked) return 'Blocked';
  if (aiEnabled === undefined) return undefined;
  return aiEnabled ? 'On' : 'Off';
};
